import { DateTime } from '../../../../../../../features/date-time/date-time';

export const FormCreateDateTimeRange = () => {
  return (
    <div style={{ display: 'flex', gap: '10px' }}>
      <DateTime onChange={() => {}} />
      <DateTime onChange={() => {}} />
    </div>
  );
};
